<div class="contacts">
  <h1 class="contacts-title">Контакты</h1>
  <p>{{ profile?.phone || '' }}</p>
  <p>{{ profile?.email || '' }}</p>
  <p class="contacts-link" (click)="navigate()">
    {{ profile?.email ? 'Изменить' : 'Добавить' }}
  </p>
</div>
